import React from "react";

import type { RootProps } from "./types";

import { RootElementContextProvider } from "./context";

export const Root = ({ children }: RootProps) => (
  <RootElementContextProvider>{children}</RootElementContextProvider>
);

// Export children
export { Trigger } from "./Trigger";
export { Content } from "./Content";
